import React from 'react';

import { withStyles } from '@material-ui/core/styles';

// import globalStyles
import globalStyles from '../../../styles/globalStyles';

// Style
const styles = (theme) => ({
  ...globalStyles(theme),
  formControl: {
    margin: theme.spacing(1, 0, 2, 0),
  },
  card: {
    minWidth: 275,
  },
  cardContent: {
    minHeight: 275,
  },
  section: {
    margin: theme.spacing(3, 0),
  },
});

/**
 * HelpdeskMainPage
 * @param {*} props
 */
const HelpdeskMainPage = (props) => {
  return (
    <div>
      <h2>หน้าหลัก-แจ้งเหตุละเมิดข้อมูลส่วนบุคคล</h2>
      <h3>Under Construction</h3>
    </div>
  );
};

export default withStyles(styles)(HelpdeskMainPage);
